import type { MouseEvent, ReactNode } from 'react';
import { href, type Route } from './router';

export interface LinkProps {
  to: Route;
  children: ReactNode;
  className?: string;
  replace?: boolean;
  /** いま開いている対象そのものを指すリンクか。ナビの現在地表示に使う。 */
  current?: boolean;
  onNavigate(route: Route, options?: { replace?: boolean }): void;
}

/**
 * 実際の <a href> を出す。直接アクセス・別タブ・右クリックのコピーを壊さないため。
 * 左クリックだけを横取りしてHistory APIで遷移する。
 */
export function Link({ to, children, className, replace, current, onNavigate }: LinkProps) {
  const url = href(to);
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onNavigate(to, replace ? { replace: true } : undefined);
  };
  return (
    <a
      href={url}
      className={className}
      aria-current={current ? 'page' : undefined}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
